const share = (url: string, text: string, handleResult?: () => void) => {
  handleResult?.()
}

export default { share }
